import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import UserForm from './userForm';
import { resetUsers } from '../../../reducers/userReducer';

interface IAddUserProps {
    classes: any;
    theme: Theme;
    match: any;
    users: any;
    steps: Array<number>;
    userId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetUsers: () => dispatch(resetUsers())
});

const mapStoreToProps = (store: RootState, ownProps: IAddUserProps) => {
    return {
        userId: ownProps.match.params?.userId ? Number(ownProps.match.params?.userId) : undefined
    };
};

class AddUser extends Component<IAddUserProps> {
    componentWillUnmount() {
        resetUsers();
    }

    render() {
        const { classes, steps, userId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <UserForm userId={userId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddUser));